import './App.css';
import './Style/style.css';
import './Style/responsive.css';
import Header from './Component/Header';
import { ToastContainer } from 'react-toastify';
import Dashboard from './Component/page/dashboard';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Route, Routes, useLocation } from 'react-router-dom';
import RestaurantsDetails from './Component/page/RestaurantsDetails';
import Checkout from './Component/page/Checkout';
import Favorite from './Component/page/Favorite';
import Orders from './Component/page/Orders';
import CategoerieDetails from './Component/page/CategoerieDetails';
import Footer from './Component/Footer';
import Pages from './Component/Pages';
import Faq from './Component/page/Faq';
import Refer from './Component/page/Refer';
import Search from './Component/page/Search';
import ResOffer from './Component/page/ResOffer';
import Wallet from './Component/page/Wallet';
import Success, { Cancel } from './Payment/PayFastRes';
import PaymentResponse from './Payment/PaymentResponse';
import NotFound from './Component/NotFound';
import { useContext } from 'react';
import { MyContext } from './Context/MyProvider';
function App() {

  const { isdmode } = useContext(MyContext);
  const Location = useLocation();
  const IsSearch = Location.pathname.startsWith("/search");
  
  return (
    <div className="App">
      <Header />

      <div className="content-wrapper">
        {isdmode ? (
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/restaurant/:id" element={<RestaurantsDetails />} />
            <Route path="/categories/:title" element={<CategoerieDetails />} />
            <Route path="/pages/:title" element={<Pages />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/favorite" element={<Favorite />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/refer-earn" element={<Refer />} />
            <Route path="/search" element={<Search />} />
            <Route path="/offers-near-me" element={<ResOffer />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/done" element={<Success />} />
            <Route path="/cancel" element={<Cancel />} />
            <Route path="/PaymentRespons" element={<PaymentResponse />} />

            <Route path="*" element={<NotFound />} />

          </Routes>
        )}
      </div>


      {(!IsSearch && !isdmode) && <Footer />}

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
